import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type ListFilter } from '../types/filters';

export const ethnicityDefinition: FilterDefinition<ListFilter> = {
  id: FilterId.ETHNICITY,
  name: 'Ethnicity',
  selectionListId: 'ethnicity',
  selections: [],
  type: FilterType.LIST,
  isVisible: true,
};

export const ethnicityHandler: FilterHandler<ListFilter> = {
  isActive(currentFilterState: ListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: ListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: ListFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<ListFilter>) {
    return [definition.selectionListId];
  },
};
